type ShouldHideAutoMemoryMenuItemOptions = {
  hasConversationMemoryPermission: boolean;
  isMemoryManagerAllowed: boolean;
};

const shouldHideAutoMemoryMenuItem = ({ hasConversationMemoryPermission, isMemoryManagerAllowed }: ShouldHideAutoMemoryMenuItemOptions): boolean => {
  return !hasConversationMemoryPermission || !isMemoryManagerAllowed;
};

export default shouldHideAutoMemoryMenuItem;
